import React, { useState } from "react";

export default function StreakComponentMini({
  initialStreak = 0,
  badgeTitle = "",
  badgeImage = "",
}) {
  const [streak, setStreak] = useState({
    count: initialStreak,
    lastActive: "2025-09-19",
    history: [
      { days: 5, badge: "🔥", title: "Getting Started" },
      { days: 10, badge: "🏆", title: "Consistency King" },
      { days: 15, badge: "🌟", title: "Half-Month Hero" },
    ],
  });

  const [showDetails, setShowDetails] = useState(false);

  return (
    <div className="p-4 rounded-2xl border border-orange-100 dark:border-slate-700 bg-gradient-to-br from-orange-50 to-white dark:from-slate-800 dark:to-slate-800 shadow-sm text-sm flex flex-col space-y-2">
      {/* Title */}
      <div className="flex items-center font-semibold text-slate-900 dark:text-slate-100">
        🔥 Daily Streak
      </div>

      {/* Main Content */}
      <div className="flex items-center justify-between">
        {/* Current streak count */}
        <div>
          <div className="text-2xl font-bold text-slate-900 dark:text-white">
            {streak.count}
          </div>
          <div className="text-xs text-slate-500 dark:text-slate-300">days</div>
        </div>

        {/* Last active + details toggle */}
        {/* <div className="text-right">
          <div className="text-xs text-slate-500 dark:text-slate-300">
            Last active
          </div>
          <div className="text-xs font-medium text-slate-700 dark:text-slate-100">
            {streak.lastActive || "—"}
          </div>
          <button
            className="mt-1 text-xs text-blue-600 dark:text-blue-400 hover:underline"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? "Hide details" : "View details"}
          </button>
        </div> */}

        <div className="text-right">
          <div className="text-xs text-slate-500 dark:text-slate-300">
            {badgeTitle}
          </div>
          <div className=" pt-2">
            <img src={badgeImage} style={{ width: "32px" }} />
          </div>
        </div>
      </div>

      {/* Expandable details */}
      {showDetails && (
        <div className="mt-3 border-t pt-2 space-y-2">
          <div className="text-xs font-semibold text-slate-700 dark:text-slate-200">
            Previous Streaks & Badges
          </div>
          <div className="space-y-2">
            {streak.history.map((item, i) => (
              <div
                key={i}
                className="flex items-center justify-between rounded-lg bg-slate-50 dark:bg-slate-700 p-2"
              >
                {/* Left: days */}
                <div className="text-sm font-medium text-slate-900 dark:text-white">
                  {item.days}d
                </div>

                {/* Right: badge + title */}
                <div className="flex items-center gap-2">
                  <span className="text-lg">{item.badge}</span>
                  <span className="text-xs text-slate-600 dark:text-slate-300">
                    {item.title}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
